export class Item
{
    description: string;
    number: number;
    value: number;
}
